import React, { useContext } from 'react';
import { GenericRoundTable, SHAPE, SeatingViewerContext } from '@wix/seating-common-components';
import { WholeTableReservationWrapper } from '../whole-table-reservation-wrapper';
export const RoundTable = ({ definition }) => {
    const { shapeTypeConfig } = useContext(SeatingViewerContext);
    const { hideSeats = false, forcedCursor = {}, perShapeConfig } = shapeTypeConfig[SHAPE.ROUND_TABLE] ?? {};
    const { fillColor, strokeColor, color } = (perShapeConfig ?? {})[definition.id] ?? {};
    return (React.createElement(WholeTableReservationWrapper, { definition: definition },
        React.createElement(GenericRoundTable, { definition: definition, hideSeats: hideSeats, fillColor: fillColor, strokeColor: strokeColor, color: color, forcedCursor: forcedCursor })));
};
//# sourceMappingURL=round-table.js.map